<template>
  <div class="article-header-default">
    <div class="header-col header-col-left">
      <div class="header-col-row">
        <slot name="title"></slot>
      </div>
      <div v-if="$slots.translit" class="header-col-row">
        <slot name="translit"></slot>
      </div>
      <div v-if="$slots.flags" class="header-col-row flags-row">
        <slot name="flags"></slot>
      </div>
    </div>
    <div v-if="$slots.stats" class="header-col header-col-right">
      <slot name="stats"></slot>
    </div>
  </div>
</template>

<style scoped>
.article-header-default {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.header-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.header-col-left {
  flex: 1;
  min-width: 0;
}

.header-col-right {
  flex-shrink: 0;
}

.header-col-row {
  display: flex;
  align-items: center;
}

.flags-row {
  gap: 8px;
}
</style>
